import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3413133a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid px-5" }
const _hoisted_2 = { class: "row mt-5" }
const _hoisted_3 = { class: "col-12 app-details" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "app-image" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fa-stack fa-2x" }, [
    /*#__PURE__*/_createElementVNode("span", {
      class: "fa-duotone fa-inbox fa-stack-2x",
      style: {"color":"#989bea"}
    }),
    /*#__PURE__*/_createElementVNode("span", {
      class: "fas fa-clock fa-stack-1x",
      style: {"font-size":"0.8em","color":"#0000dd","margin-top":"-6px"}
    })
  ])
], -1))
const _hoisted_5 = { class: "app-info" }
const _hoisted_6 = { class: "app-description" }
const _hoisted_7 = { class: "app-buttons" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-plus fa-fw me-1" }, null, -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Install ")
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"col-12 app-screens\" data-v-3413133a><div class=\"app-screen\" data-v-3413133a></div><div class=\"app-screen\" data-v-3413133a></div><div class=\"app-screen\" data-v-3413133a></div><div class=\"app-screen\" data-v-3413133a></div><div class=\"app-screen\" data-v-3413133a></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.app.title), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.app.description), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.installApp()))
          }, _hoisted_10)
        ])
      ]),
      _hoisted_11
    ])
  ]))
}